<script lang="ts">
    import CN from "classnames";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    import type SliderControllerInterface from "./SliderControllerInterface";

    let className: string | undefined = undefined;
    export { className as class };
    export let currentIndex: number;
    export let sliderController: SliderControllerInterface;
    export let perPage = 3;
    export let slidesCount: number;
    export let step = 1;

    let dotsCount = 0;

    $: {
        slidesCount;
        dotsCount = Math.ceil((slidesCount - perPage) / step) + 1;
    }
    const handleDots = (index: number) => {
        sliderController.goToIndex(index);
    };
</script>

<ul class={CN("gw-dots gw-list-reset-default-styles", className)}>
    {#if dotsCount && dotsCount > 1}
        {#each { length: dotsCount } as _, index}
            <li class="gw-dots__dot">
                <BaseButton
                    class={CN("gw-dots__button", {
                        "gw-dots__button--active": currentIndex === index,
                    })}
                    on:click={() => handleDots(index)}
                    ariaLabel={`Go to slide ${index + 1}`}
                >
                    <slot />
                </BaseButton>
            </li>
        {/each}
    {/if}
</ul>

<style lang="postcss">
    .gw-dots {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        column-gap: 10px;
    }
</style>
